// Touch devices have no hover, so the secondary product image (normally revealed
// on :hover, see component-product-item.css) never shows. Delegated so it works for
// cards rendered later via AJAX (facets, cart recommendations, quick add) without
// needing to be re-bound.
if ( document.body.classList.contains('touchevents') ) {

	let activeCard = null;

	document.addEventListener('touchstart', (event) => {
		const card = event.target.closest('.product-item__image--has-secondary');
		if ( ! card ) return;
		if ( activeCard && activeCard !== card ) activeCard.classList.remove('touch-active');
		card.classList.add('touch-active');
		activeCard = card;
	}, { passive: true });

	document.addEventListener('touchend', () => {
		if ( ! activeCard ) return;
		const card = activeCard;
		activeCard = null;
		// Keep the secondary image visible briefly after release so it's actually seen,
		// without blocking the tap's normal click/navigation.
		setTimeout(() => card.classList.remove('touch-active'), 800);
	}, { passive: true });

}
